<div class="bg-m1 flex h-full cursor-default flex-col">
  <div
    class="mx-4 mb-4 mt-6 flex h-2 flex-grow flex-col sm:mx-6 sm:mb-6 sm:mt-8"
  >
    <div class="flex min-h-11 flex-row items-center justify-start">
      <div
        data-cy="projectProvidersTitle"
        class="text-s1 flex select-none text-2xl font-semibold"
        >{{ pageTitle }}</div
      >

      <div
        class="ml-6 sm:ml-10"
        tp="Admin role required"
        [tpIsEnabled]="isAdmin === false"
      >
        <button
          data-cy="projectProvidersAddProviderButton"
          class="text-m0 h-11 flex-shrink-0 select-none rounded px-4 py-2 text-base font-medium focus:outline-none sm:px-5"
          type="button"
          [ngClass]="{
            'bg-m600': isAdmin === true,
            'bg-s400 cursor-default': isAdmin === false
          }"
          (click)="addProvider()"
          [disabled]="isAdmin === false"
          >Add Provider</button
        >
      </div>
    </div>

    <div class="bg-m0 mt-6 flex-grow overflow-auto rounded shadow">
      <ng-scrollbar
        [orientation]="'auto'"
        [visibility]="'hover'"
        [appearance]="'compact'"
        *ngIf="providers.length > 0"
      >
        <div class="text-s1 mx-5 mt-8 min-w-[1860px]">
          <table class="divide-s500 min-w-full table-fixed divide-y">
            <thead>
              <tr class="h-12 text-sm">
                <th class="w-[100px] select-none text-left"></th>
                <th class="w-24 select-none text-left"></th>
                <th class="w-28 select-none pr-8 text-left">Enabled</th>
                <th class="w-10 select-none text-left"></th>
                <th class="w-48 select-none pr-8 text-left">Name</th>
                <th class="w-[700px] select-none pr-8 text-left">Models</th>
                <th class="w-96 select-none pr-8 text-left">URL</th>
                <th class="select-none pr-8 text-left">Extra</th>
              </tr>
            </thead>

            <tbody class="text-base">
              <tr aria-hidden="true" class="h-2">
                <td colspan="8"></td>
              </tr>

              <tr
                *ngFor="let provider of providers; let isFirst = first"
                class="border-s300 h-16 align-top"
                [class.border-t]="!isFirst"
              >
                <td class="w-[100px] py-3">
                  <div
                    class="w-fit"
                    tp="Admin role required"
                    [tpIsEnabled]="isAdmin === false"
                  >
                    <button
                      data-cy="projectProvidersDeleteButton"
                      class="ml-5 h-9 w-9 rounded focus:outline-none"
                      [ngClass]="{
                        'text-s1 hover:bg-m200': isAdmin === true,
                        'text-s400 cursor-default': isAdmin === false
                      }"
                      [disabled]="isAdmin === false"
                      (click)="deleteProvider({ provider: provider })"
                    >
                      <div class="flex justify-center">
                        <m-trash-icon></m-trash-icon>
                      </div>
                    </button>
                  </div>
                </td>

                <td class="w-24 py-3">
                  <div
                    class="w-fit"
                    tp="Admin role required"
                    [tpIsEnabled]="isAdmin === false"
                  >
                    <button
                      data-cy="projectProvidersEditButton"
                      class="h-9 select-none rounded border px-3 text-base leading-3 shadow-sm focus:outline-none"
                      [ngClass]="{
                        'border-s400 text-s500 hover:bg-s100': isAdmin === true,
                        'border-s300 text-s400 cursor-default':
                          isAdmin === false
                      }"
                      [disabled]="isAdmin === false"
                      (click)="editProvider({ provider: provider })"
                      >Edit</button
                    >
                  </div>
                </td>

                <td class="w-28 py-4 pr-8">
                  <div
                    class="w-fit"
                    tp="Admin role required"
                    [tpIsEnabled]="isAdmin === false"
                  >
                    <div
                      class="flex max-w-min items-center"
                      [ngClass]="{
                        'cursor-pointer': isAdmin === true,
                        'cursor-default': isAdmin === false
                      }"
                      (click)="toggleProvider({ provider: provider })"
                    >
                      <ui-switch
                        [checked]="provider.isEnabled"
                        [disabled]="isAdmin === false"
                        color="#64BD63"
                      ></ui-switch>
                    </div>
                  </div>
                </td>
                <td class="w-10 py-5">
                  <m-provider-icon
                    [providerId]="provider.providerId"
                    class="text-s500 relative top-px"
                  ></m-provider-icon>
                </td>
                <td class="w-48 py-5 pr-8">
                  {{ provider.name }}
                </td>
                <td class="w-[700px] pr-8">
                  <div class="flex flex-row items-center">
                    <div
                      tp="Admin role required"
                      [tpIsEnabled]="isAdmin === false"
                    >
                      <button
                        data-cy="projectProvidersAddModelButton"
                        class="flex h-8 w-8 items-center justify-center rounded focus:outline-none"
                        [ngClass]="{
                          'text-s400 cursor-default': isAdmin === false,
                          'text-m600 hover:bg-m200': isAdmin === true
                        }"
                        [disabled]="isAdmin === false"
                        (click)="addLlmModel({ provider: provider })"
                        aria-label="Add model"
                      >
                        <m-add-icon></m-add-icon>
                      </button>
                    </div>

                    <div class="my-3 ml-5 flex min-w-[600px] flex-col">
                      <div
                        *ngFor="let model of provider.models"
                        class="group flex h-9 flex-row items-center text-base"
                      >
                        <div class="text-s1 truncate">
                          {{ model.name }}
                        </div>

                        <div
                          class="ml-auto flex flex-shrink-0 select-none gap-2 text-xs"
                        >
                          <span
                            class="rounded px-2.5 py-1 text-sm"
                            [ngClass]="{
                              'bg-g100 text-g700':
                                model.isOpencodeSupported && model.isBuilder,
                              'bg-s150 text-s400':
                                model.isOpencodeSupported &&
                                model.isBuilder === false,
                              'bg-r100 text-r700':
                                model.isOpencodeSupported === false
                            }"
                            [title]="
                              model.isOpencodeSupported === false
                                ? 'OpenCode filters out this model'
                                : ''
                            "
                            >Builder</span
                          >
                          <span
                            class="rounded px-2.5 py-1 text-sm"
                            [ngClass]="{
                              'bg-g100 text-g700': model.isExplorer,
                              'bg-s150 text-s400': model.isExplorer === false
                            }"
                            >Explorer</span
                          >
                          <span
                            class="relative top-[3px] ml-1 w-14 text-right text-sm"
                            [ngClass]="{
                              'text-m600':
                                provider.type ===
                                  providerTypeEnum.OpenAICompatible ||
                                model.isManual === true,
                              'text-s400':
                                provider.type !==
                                  providerTypeEnum.OpenAICompatible &&
                                model.isManual !== true
                            }"
                            [tp]="
                              provider.type ===
                                providerTypeEnum.OpenAICompatible ||
                              model.isManual === true
                                ? 'User-provided value'
                                : model.contextLimit !== undefined
                                  ? 'Context window'
                                  : model.inputLimit !== undefined
                                    ? 'Max input tokens'
                                    : 'Context window'
                            "
                            [tpIsEnabled]="true"
                          >
                            {{
                              formatContextLimit({
                                contextLimit:
                                  model.contextLimit ?? model.inputLimit
                              })
                            }}
                          </span>
                        </div>

                        <div
                          tp="Admin role required"
                          [tpIsEnabled]="isAdmin === false"
                          class="ml-4"
                        >
                          <button
                            data-cy="projectProvidersEditModelButton"
                            class="flex h-8 w-8 items-center justify-center rounded focus:outline-none"
                            [ngClass]="{
                              'text-s400 cursor-default': isAdmin === false,
                              'text-s1 hover:bg-m200': isAdmin === true
                            }"
                            [disabled]="isAdmin === false"
                            (click)="
                              editLlmModel({
                                provider: provider,
                                model: model
                              })
                            "
                            aria-label="Edit model"
                          >
                            <m-edit-icon></m-edit-icon>
                          </button>
                        </div>

                        <div
                          tp="Admin role required"
                          [tpIsEnabled]="isAdmin === false"
                          class="ml-2"
                        >
                          <button
                            data-cy="projectProvidersDeleteModelButton"
                            class="flex h-8 w-8 items-center justify-center rounded focus:outline-none"
                            [ngClass]="{
                              'text-s300 cursor-default': isAdmin === false,
                              'text-s1 hover:bg-m200': isAdmin === true
                            }"
                            [disabled]="isAdmin === false"
                            (click)="
                              deleteLlmModel({
                                provider: provider,
                                model: model
                              })
                            "
                            aria-label="Delete model"
                          >
                            <m-delete-icon></m-delete-icon>
                          </button>
                        </div>
                      </div>

                      <div
                        class="text-s400 flex h-8 items-center"
                        *ngIf="provider.models.length === 0"
                        >No models</div
                      >
                    </div>
                  </div>
                </td>
                <td class="w-96 break-all py-5 pr-8">
                  <ng-container
                    *ngIf="provider.type === providerTypeEnum.OpenAICompatible"
                  >
                    {{ provider.options.baseURL }}
                  </ng-container>
                  <span
                    *ngIf="provider.type === providerTypeEnum.OpenAICodex"
                    class="text-s400"
                    >User's Codex subscription</span
                  >
                  <span
                    *ngIf="
                      provider.type === providerTypeEnum.OpenAI ||
                      provider.type === providerTypeEnum.Anthropic
                    "
                    class="text-s400"
                    >Official provider API</span
                  >
                </td>
                <td class="break-all py-5 pr-8">
                  <div
                    [ngClass]="{
                      'text-g700':
                        provider.options.apiKey !== undefined &&
                        provider.options.apiKey !== null,
                      'text-s400':
                        provider.options.apiKey === undefined ||
                        provider.options.apiKey === null
                    }"
                    *ngIf="provider.type !== providerTypeEnum.OpenAICodex"
                  >
                    {{
                      provider.options.apiKey !== undefined &&
                      provider.options.apiKey !== null
                        ? 'API key is set'
                        : 'API key is not set'
                    }}
                  </div>

                  <div
                    class="flex-col"
                    *ngIf="
                      provider.type === providerTypeEnum.OpenAICompatible &&
                      (provider.options.headers?.length ?? 0) > 0
                    "
                  >
                    <div class="mt-3 font-medium">Headers:</div>
                    <div *ngFor="let header of provider.options.headers">
                      <span class="ml-5 font-medium">{{ header.key }}: </span>
                      <span class="text-g700">{{ header.value }}</span>
                    </div>
                  </div>

                  <div
                    class="flex-col"
                    *ngIf="
                      provider.type === providerTypeEnum.OpenAICompatible &&
                      (provider.options.queryParams?.length ?? 0) > 0
                    "
                  >
                    <div class="mt-2 font-medium">Query Parameters:</div>
                    <div
                      *ngFor="let queryParam of provider.options.queryParams"
                    >
                      <span class="ml-5 font-medium"
                        >{{ queryParam.key }}:
                      </span>
                      <span class="text-g700">{{ queryParam.value }}</span>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-scrollbar>

      <div
        class="text-s1 flex h-full w-full select-none items-center justify-center text-xl"
        *ngIf="providers.length === 0"
        >No providers</div
      >
    </div>
  </div>
</div>

<div *ngIf="projectId$ | async"></div>
<div *ngIf="isAdmin$ | async"></div>
<div *ngIf="providers$ | async"></div>
